var _rect, _path;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgFacebook = props => /*#__PURE__*/React.createElement(SvgIcon, props, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1.668,
  y: 1.666,
  width: 16.667,
  height: 16.667,
  rx: 8.333,
  fill: "#0B84EE"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.454 11.782h2.326l.365-2.343h-2.692V8.158c0-.973.321-1.837 1.24-1.837h1.475V4.277c-.26-.035-.808-.111-1.844-.111-2.163 0-3.432 1.133-3.432 3.714v1.559H6.668v2.343h2.224v6.476c.276.086.887.074 1.345.074.414 0 .818-.038 1.217-.09v-6.46z",
  fill: "#fff"
})));
export default SvgFacebook;